/**
 * 라이브러리 섹션 chip 아이콘 코드 화이트리스트.
 *
 * 모바일 `lib/screens/library/widgets/library_section_icon_map.dart`의 키와
 * 동기화되어야 한다. 새 코드 추가 시 두 곳 모두 갱신.
 */
export interface LibrarySectionIconOption {
    code: string;
    /** 어드민 드롭다운에 표시되는 라벨 (코드 + 한글 설명) */
    label: string;
}

export const LIBRARY_SECTION_ICON_OPTIONS: LibrarySectionIconOption[] = [
    { code: 'star', label: 'star (별)' },
    { code: 'fire', label: 'fire (불꽃)' },
    { code: 'gift', label: 'gift (선물)' },
    { code: 'crown', label: 'crown (왕관)' },
    { code: 'school', label: 'school (학교)' },
    { code: 'book', label: 'book (책)' },
    { code: 'book-open', label: 'book-open (책 펼침)' },
    { code: 'bulb', label: 'bulb (전구)' },
    { code: 'paint-board', label: 'paint-board (팔레트)' },
    { code: 'champion', label: 'champion (트로피)' },
    { code: 'cards', label: 'cards (카드)' },
    { code: 'compass', label: 'compass (나침반)' },
    { code: 'birthday-cake', label: 'birthday-cake (케이크)' },
    { code: 'check-list', label: 'check-list (체크리스트)' },
    { code: 'ai-brain', label: 'ai-brain (AI 두뇌)' },
    { code: 'ai-book', label: 'ai-book (AI 책)' },
];
